import './Blog.scss';
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import TitleContentBlock from '../../components/TitleContentBlock/TitleContentBlock';
import BlogSection from '../../templates/BlogSection/BlogSection';
import blogData from "../../data/blog-articles.json";
import { useState } from 'react';
import { Helmet } from 'react-helmet';

function Blog() {
  const postsPerPage = 6;
  const [currentPage, setCurrentPage] = useState(1);

  const totalPages = Math.ceil(blogData.length / postsPerPage);
  const startIndex = (currentPage - 1) * postsPerPage;
  const endIndex = startIndex + postsPerPage;
  const currentPosts = blogData.slice(startIndex, endIndex);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handlePrev = () => {
    setCurrentPage((prev) => {
      const updated = Math.max(prev - 1, 1);
      setTimeout(scrollToTop, 0); 
      return updated;
    });
  };

  const handleNext = () => {
    setCurrentPage((prev) => {
      const updated = Math.min(prev + 1, totalPages);
      setTimeout(scrollToTop, 0);  
      return updated;
    });
  };

  return (
    <div className="page-layout">
      <Helmet>
        <title>Blog - Sony Chen</title>
        <meta name="description" content="Explore Sony Chen’s blog entries and design thoughts." />
      </Helmet>

      <Header />
      <main className="page-layout-main">
        <div className="page-layout-main__wrapper">
          <TitleContentBlock 
            header="Design " 
            headerUnderline="Diary"
            isSparkle={true}
            body="From concept to execution, here are some pieces I’ve brought to life."
          />

          <BlogSection 
            data={currentPosts} 
            currentPage={currentPage}
            totalPages={totalPages}
            handlePrev={handlePrev}
            handleNext={handleNext}
          />
        </div>
        <Footer />
      </main>
    </div>
  );
}

export default Blog;